import { useTranslation } from 'react-i18next';
import { ListingFeatureStatEnum } from '~/pages/FeatureListing/enums';
import { ListingFeatureStatType } from '~/types/featureListingTypes';

export default function FeatureStats({
  stats,
}: {
  stats: ListingFeatureStatType[];
}) {
  const { t } = useTranslation('app');
  const statsLabel: Record<ListingFeatureStatEnum, string> = {
    [ListingFeatureStatEnum.CALLS]: t('featureStatCalls'),
    [ListingFeatureStatEnum.VIEWS]: t('featureStatViews'),
    [ListingFeatureStatEnum.IMPRESSIONS]: t('featureStatImpressions'),
  };

  return (
    <div className="flex w-full items-center">
      {stats.map((stat, index) => (
        <div
          key={stat.key}
          className={`flex flex-1 flex-col items-center gap-0.5x px-x ${
            index === 0 ? '' : 'border-s border-gray'
          }`}
        >
          <p className="text-title-4 text-gray__dark_2">
            {t('featureMultiplierValue', { value: stat.multiplier })}
          </p>
          <p className="text-caption-1 text-gray__dark_1">
            {statsLabel[stat.key as ListingFeatureStatEnum]}
          </p>
        </div>
      ))}
    </div>
  );
}
